/*
 * File: referralBannerDiscount.styles.tsx
 * Project: meki
 * File Created: Wednesday, 3rd May 2023 8:43:19 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 3rd May 2023 9:33:10 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { LoyaltyDiscountTag } from '@components/icons/LoyaltyDiscountTag';
import { IconButton, Typography } from '@mui/material';
import { styled } from '@mui/system';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#EFF5EF',
  position: 'sticky',
  bottom: 0,
  left: 0,
  width: '100%',
  minHeight: '58px',
  maxHeight: '80px',
  zIndex: 500,
  gap: '10px',
});

const GiftAmountTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '150%',
  [theme.breakpoints.up(700)]: {
    fontSize: '18px',
  },
  letterSpacing: '-0.011em',
  color: '#00A650',
}));

const ValidityTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '150%',
  [theme.breakpoints.up(700)]: {
    fontSize: '12px',
  },
  letterSpacing: '-0.011em',
  color: '#284525',
}));

const CloseIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '5px',
  right: '5px',
}));

const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});
const IconContainer = styled('div')({
  width: '45px',
  height: '45px',
  borderRadius: '30px',
  backgroundColor: ' #00A6504D',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const LoyaltyDiscountTagStyled = styled(LoyaltyDiscountTag)({
  width: '27px',
  height: '27px',
});

export {
  RootDiv,
  GiftAmountTypography,
  ValidityTypography,
  CloseIconButton,
  TextContainer,
  IconContainer,
  LoyaltyDiscountTagStyled,
};
